// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmallTalkNavigation__smallTalkNavigation___2n_1a{padding-top:8px;margin-top:0}.SmallTalkNavigation__smallTalkNavigationHeader___2NLhc{font-size:14px;color:#777;font-weight:600;text-transform:uppercase;padding:14px;padding-bottom:16px;border-bottom:1px solid #eee}.SmallTalkNavigation__testBot___3NI6e{width:100%;height:42px;font-size:14px}.SmallTalkNavigation__testBot___3NI6e .SmallTalkNavigation__testBotIcon___RuHxB{margin-right:8px;width:20px;height:20px;transform:translateY(-1px)}.SmallTalkNavigation__testBotWrapper___3Q2Ex{padding:13px;background:#fff;box-shadow:0 2px 18px 0 rgba(0,0,0,0.16);z-index:9999999999}\n", ""]);
// Exports
exports.locals = {
	"smallTalkNavigation": "SmallTalkNavigation__smallTalkNavigation___2n_1a",
	"smallTalkNavigationHeader": "SmallTalkNavigation__smallTalkNavigationHeader___2NLhc",
	"testBot": "SmallTalkNavigation__testBot___3NI6e",
	"testBotIcon": "SmallTalkNavigation__testBotIcon___RuHxB",
	"testBotWrapper": "SmallTalkNavigation__testBotWrapper___3Q2Ex"
};
module.exports = exports;
